var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"echart",staticStyle:{"height":"100%"}},[_vm._v("询盘数据加载中...")])}
var staticRenderFns = []

export { render, staticRenderFns }